export default __webpack_public_path__ + "static/media/LVBOOTH-600.7323362b.jpg";